import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'cmx-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
})
export class CmxLoadingComponent implements OnInit {
  @Input()
  public size: string;

  @Input()
  public descriptionShow: boolean;

  @Input()
  public label = '';

  constructor() {}

  ngOnInit() {}
}
